import type { SheetParameterValues } from "building-types/systemParameterTypes";
import { WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID, type SheetTemplateInstance } from "building-types/views/planSets";

export function sheetParameterValuesFromSheet(
  instance: Pick<SheetTemplateInstance, "sheetNumber" | "sheetNumberPrefix" | "name" | "id">,
): Partial<SheetParameterValues> {
  if (instance.id === WRAPPER_CONTENT_TEMPLATE_INSTANCE_ID) {
    return {};
  }
  return {
    currentSheetNumber: instance.sheetNumber,
    currentSheetNumberPrefix: instance.sheetNumberPrefix,
    currentSheetName: instance.name,
  };
}
